import { OnChangeParams } from 'baseui/select';
import { supportedEmbeddingAttributeMetrics } from '@tigergraph/tools-models';
import { AttributeSelect } from '@/components/schemaDesigner/attributeEditorContainer/attributeEditor/AttributeSelect';

export interface EmbeddingAttributeMetricSelectProps {
  metric: string;
  readOnly?: boolean;
  onChange: (metric: string) => void;
}

export default function EmbeddingAttributeMetricSelect({
  metric,
  readOnly,
  onChange,
}: EmbeddingAttributeMetricSelectProps) {
  const options = supportedEmbeddingAttributeMetrics.map((type) => ({ id: type, label: type }));

  const handleChange = ({ value }: OnChangeParams) => {
    if (value.length > 0) {
      const newMetric = value[0].id as string;
      onChange(newMetric);
    }
  };

  return (
    <AttributeSelect
      disabled={readOnly}
      options={options}
      value={[{ id: metric, label: metric }]}
      onChange={handleChange}
      placeholder="Select metric"
    />
  );
}
